import CreateReducer from '../utils/createReducer'
import CreateActions from '../utils/createActions'

import {
  handlers,
} from '../utils/api'

import networkWrapper from '../utils/networkWrapper'

const prefix = 'pool'
const wrapper = networkWrapper.factory(prefix)

const initialState = {
  data: [],
}

const reducers = {
  setData: (state, action) => {
    state.data = action.payload
  },
}

const sideEffects = {

  load: () => wrapper('load', async (dispatch, getState) => {
    const data = await handlers.get(`/pools`)
    await dispatch(actions.setData(data))
  }),

  loadSilently: () => wrapper('loadSilently', async (dispatch, getState) => {
    const data = await handlers.get(`/pools`)
    await dispatch(actions.setData(data))
  }, {
    globalLoading: false,
  }),

}

const reducer = CreateReducer({
  initialState,
  reducers,
  prefix,
})

const actions = CreateActions({
  reducers,
  sideEffects,
  prefix,
})

export { actions, reducer }
export default actions
